import React, { useState } from 'react'
import { 
  useTheme,
  Box,
  TextField,
  Avatar,
  Paper,
  Typography,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import IconButton from '@mui/material/IconButton';
import useIsMobile from '../../../hooks/useIsMobile';
import useCurrentUserInfo from '../../../hooks/useCurrentUserInfo';
import { useSelector } from 'react-redux';

function AISousPreview() {
  const theme = useTheme();
  const userInfo = useCurrentUserInfo();
  const mobile = useIsMobile();
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);

  const chefProfileInfo = useSelector((state) => state?.userData?.chefProfileInfo);

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (message.trim()) {
      // console.log(message);
      setMessage('');
    }
  };

  return (
    <Box 
      sx={{ 
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      {/* Chat Area */}
      <Box
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: messages.length === 0 ? 'center' : 'flex-start',
          alignItems: 'center',
        }}
      >
        {messages.length === 0 ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3,
              maxWidth: '600px',
              width: '100%',
              p: 2,
            }}
          >
            <Box
              sx={{
                position: 'relative',
                width: 152,
                height: 152,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: `0.35rem solid ${theme.palette.primary.main}`,
                borderRadius: '50%',
                backgroundColor: `${theme.palette.secondary.main}`,
              }}
            >
              <Avatar
                sx={{
                  width: 120,
                  height: 120,
                  bgcolor: theme.palette.primary.main,
                  boxShadow: 3,
                }}
                alt="Chef Avatar"
                src={chefProfileInfo?.chefProfileAvatar}
              />
            </Box>
            <Paper
              elevation={3}
              sx={{
                borderRadius: 4,
                padding: '1rem',
                backgroundColor: theme.palette.primary.main,
                position: 'relative',
                maxWidth: '90%',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: -20,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  borderWidth: 10,
                  borderStyle: 'solid',
                  borderColor: `transparent transparent ${theme.palette.primary.main} transparent`,
                }
              }}
            >
              <Typography
                variant="h6"
                align="center"
                sx={{
                  color: theme.palette.secondary.main,
                  fontWeight: 500,
                  lineHeight: 1.4,
                }}
              >
                Here your users will have a welcome message from you inviting them to speak with your AI Sous Chef. The AI here will only use recipes from your library.
              </Typography>
            </Paper>
          </Box>
        ) : (
          messages.map((msg, index) => (
            <Box key={index}>
              {/* Message content */}
            </Box>
          ))
        )}
      </Box>

      {/* Message Input Area */}
      <Paper
        component="form"
        onSubmit={handleSubmit}
        sx={{
          p: 2,
          borderTop: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
          width: '100%',
        }}
        elevation={3}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <TextField
            disabled
            fullWidth
            multiline
            maxRows={3}
            value={message}
            onChange={handleMessageChange}
            placeholder="Type your message..."
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              },
            }}
          />
          <IconButton 
            disabled
            type="submit" 
            color="primary" 
            sx={{ 
              p: 1,
              mb: 0.5,
              bgcolor: theme.palette.primary.main,
              color: theme.palette.secondary.main,
              '&:hover': {
                bgcolor: theme.palette.primary.dark,
              },
            }}
          >
            <SendIcon />
          </IconButton>
        </Box>
      </Paper>
    </Box>
  );
}

export default AISousPreview;